import '../styles/redwall/index.scss';
import './RedwallLayout.scss';

export function RedwallLayout(props) {
  const { className, children } = props;

  return (
    <div className={`redwall-layout grid-root ${className}`.trim()}>
      {children}
    </div>
  );
}
